var GlobalEventBus = {};

export { GlobalEventBus as __exports };
//# sourceMappingURL=GlobalEventBus.js.map
